export default __webpack_public_path__ + "static/media/smileweb.bc2312dd.png";